<template>
    <div class="auth-layout">
        <div class="auth-layout_brand">
            <img
                src="@/assets/logo-color.png"
                alt="Forth Logo"
                class="auth-layout_brand-image"
            >
        </div>
        <main class="auth-layout_main">
            <router-view />
        </main>
        <div class="auth-layout_footer" v-if="showForgotPassword">
            <router-link to="/remind-password" class="auth-layout_forgot-password-link">
                Forgot Your Password?
            </router-link>
        </div>
    </div>
</template>

<script setup lang="ts">

const props = defineProps<{
    showForgotPassword: boolean;
}>();
</script>

<style lang="scss">
.auth-layout {
    display: flex;
    flex-direction: column;
    height: 100vh;
    align-items: center;

    &_brand {
        margin-top: 6%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &_brand-image {
        display: block;
        width: 228px;
        height: 60px;
        max-width: 100%;
    }

    &_main {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 90px;
    }

    &_footer {
        margin-top: 24px;
        display: flex;
        justify-content: center;
    }

    &_forgot-password-link {
        font-weight: 300;
        font-size: 13px;
        letter-spacing: 3%;
        color: $black-color;
        bottom: 5%;
        position: absolute;
        text-underline-offset: 25%;
        text-decoration: underline;
    }

    .auth-form {
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: start;
        width: 100%;
        max-width: 500px;
        padding: 0 50px;
        @media (max-width: 540px) {
            padding: 0 24px;
        }
        &_error-msg {
            display: block;
            font-size: 13px;
            color: $error-red;
            position: absolute;
            bottom: -18px;
        }
        &_error-form-msg-container {
            position: relative;
            width: 100%;
        }
        &_error-form-msg {
            font-size: 15px;
            color: $error-red;
            position: absolute;
            width: 100%;
            text-align: center;
        }
        &_logo {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
        }
        &_header {
            display: flex;
            align-items: center;
            justify-content: start;
            gap: 22px;
            h2 {
                margin: 0;
                font-weight: 600;
                font-size: 24px;
                color: $auth-layout-font-color;
                line-height: 28px;
            }
            .fa-solid.fa-key,
            .fa-solid.fa-arrow-right-to-bracket {
                color: $main-orange;
                font-size: 16px;
            }
        }
        &_inputs {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 25px;
            width: 100%;
            margin-top: 45px;
            hr {
                height: 2px;
                background-color: $hr-gray-color;
                border-color: $hr-gray-color;
                width: 100%;
                border-style: none;
                margin: 10px 0;
            }
        }
        &_input-group {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: start;
            justify-content: start;
            gap: 8px;
            position: relative;
            label {
                margin-left: 20px;
                font-size: 15px;
                font-weight: 300;
                color: $auth-layout-font-color;
            }
            .p-inputtext {
                height: 57px;
                font-size: 16px;
                font-weight: 400;
                padding: 20px 25px;
                border: 1px solid $border-gray-color;
                border-radius: 10px;
                &:enabled:focus {
                    border-color: $main-orange;
                    &.p-invalid {
                        border-color: $error-red;
                    }
                }
                &.p-invalid {
                    border-color: $error-red;
                }
            }
        }
        &_row-input-group {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        &_row-input-group-item {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            label {
                font-weight: 300;
                font-size: 13px;
                letter-spacing: 3%;
                color: $black-color;
            }
            .p-button {
                padding: 15px 46px;
                font-weight: 600;
                font-size: 16px;
                line-height: 100%;
                color: $white-color;
                background: $main-orange;
                border-color: $main-orange;
                &:hover {
                    background: $main-orange-hover;
                    border-color: $main-orange-hover;
                }
            }
        }
    }
}
</style>
